module.exports = __webpack_public_path__ + "static/media/close.112d7c89.svg";